import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input } from "reactstrap";
import usexAPI from "store/customHooks/usexAPI";

import icon_close_w2 from "styles/common/img/myplan/icon_close_w2.png";
import myplan_l_img16 from "styles/common/img/myplan/info.png";
import { callPost } from "utils/CommonApi";
import { xAPI_IA } from "utils/xAPI_IA";
import Constants from "common/Constants";
import { useSelector } from "react-redux";
import SchlSearchList from "./SchlSearchList";

const SchlSearchPop = (props) => {
    const { Screen } = usexAPI();
    const { buttonLabel, className, myInitInfo, setMyInitInfo } = props;
    // 학교 찾기 모달

    const userId = useSelector((state) => state.loginReducer.userId);

    const [schlNm, setSchlNm] = useState(""); //최종 선택한 학교명
    const [searchSchlNm, setSearchSchlNm] = useState(""); //검색 결과 학교명
    const [inputSchlNm, setInputSchlNm] = useState(""); // 검색어
    const [schlCdList, setSchlCdList] = useState([]); // 학교 검색 결과
    const [modal, setModal] = useState(false);

    const location = useLocation();
    const isPathName = location.pathname;

    useEffect(() => {
        setSchlNm(myInitInfo.schlNm);
    }, [myInitInfo]);

    useEffect(() => {
        if (modal) {
            const IAContent = xAPI_IA.MyPage_Info_SchoolSearch.IA;
            Screen().setContent({ IAContent }).opened();
        }
    }, [modal]);

    const headerParam = {
        user_id: userId,
    };

    const toggle = () => {
        setSchlCdList([]);
        setInputSchlNm("");
        setSearchSchlNm("");
        setModal(!modal);
    };

    const closeBtn = (
        <button className="close" onClick={toggle}>
            <img src={icon_close_w2} alt="닫기" />
        </button>
    );

    // 학교 찾기
    const callSchlSearch = () => {
        if (!inputSchlNm) {
            return;
        }
        let queryParam = {};
        const param = {
            REQUEST_API: Constants.STUDY_PLAN_API.SCHL_CD_LIST + "?SCHL_NM=" + inputSchlNm,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(
            headerParam,
            param,
            (resData) => {
                if (resData.RESP_RESULT.SCHL_CD_LIST) {
                    setSchlCdList(resData.RESP_RESULT.SCHL_CD_LIST);
                    setSearchSchlNm(inputSchlNm);
                }
            },
            queryParam,
        );
    };

    const clickSchlCds = (schlsCd, schlNm) => {
        setSchlNm(schlNm);
        setMyInitInfo({
            ...myInitInfo,
            schlCd: schlsCd,
            schlNm: schlNm,
            schlCdFlag: "Y",
        });
    };

    const onKeyPress = (e) => {
        if (e.key == "Enter") {
            callSchlSearch();
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <div className="d_inb find_sch_div">
            <Input type="text" name="school" id="school" placeholder="학교 찾기" value={schlNm} readOnly />
            <button type="button" className="findschool" onClick={toggle} color="#f7901e" style={{ boxShadow: "none" }}>
                {buttonLabel}
            </button>

            <Modal isOpen={modal} toggle={toggle} className={className}>
                <ModalHeader toggle={toggle} close={closeBtn} className="pop_header">
                    우리학교 찾기
                </ModalHeader>
                <ModalBody className="pop_body">
                    <p className="text">찾으시는 학교명을 입력해 주세요.</p>
                    <p className="text2">예) 언북중, 언북</p>
                    <Form className="find_sch_Form" onSubmit={handleSubmit}>
                        <FormGroup>
                            <div className="find_sch_wrap">
                                <Input
                                    type="text"
                                    name="inputSchlNm"
                                    id="inputSchlNm"
                                    placeholder="학교 이름 검색"
                                    onChange={(e) => {
                                        setInputSchlNm(e.target.value);
                                    }}
                                    onKeyPress={onKeyPress}
                                />
                                <Button
                                    onClick={callSchlSearch}
                                    color="#f7901e"
                                    style={{ boxShadow: "none", color: "#fff" }}
                                >
                                    검색
                                </Button>
                            </div>
                        </FormGroup>
                        <FormGroup className="result">
                            {schlCdList?.length > 0 ? (
                                <>
                                    <h3>
                                        <span>‘{searchSchlNm}’(으)</span>로 찾은 결과입니다.
                                    </h3>
                                    <ul>
                                        {schlCdList.map((schlData, index) => (
                                            <SchlSearchList
                                                key={index}
                                                schlData={schlData}
                                                clickSchlCds={clickSchlCds}
                                                toggle={toggle}
                                                myInitInfo={myInitInfo}
                                                isPathName={isPathName}
                                            />
                                        ))}
                                    </ul>
                                </>
                            ) : searchSchlNm && schlCdList?.length == 0 ? (
                                <div className="empty2 util_sch_empty2">
                                    <div>
                                        <img src={myplan_l_img16} alt="검색 결과가 없습니다." />
                                        <h3>검색 결과가 없습니다.</h3>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </FormGroup>
                    </Form>
                </ModalBody>
                {schlCdList?.length == 0 && (
                    <ModalFooter>
                        <div className="find_desc">
                            <p className="find_text">
                                [우리학교 찾기] 서비스는 중학교만 지원합니다. <br />
                                고등학교는 검색되지 않으니 고등과정 회원은 중학교 등록 상태를 유지해주세요.
                            </p>
                        </div>
                    </ModalFooter>
                )}
            </Modal>
        </div>
    );
};

export default SchlSearchPop;
